import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import { Controller } from "@hotwired/stimulus";

const ContactTypesListWrapper = lazy(
  () =>
    import("../../components/administration/contactTypes/ContactTypesListWrapper"),
);

// Connects to data-controller="administration--contact-types-list"
export default class extends Controller {
  connect() {
    this.root = createRoot(this.element);
    this.root.render(
      <Suspense fallback={null}>
        <ContactTypesListWrapper />
      </Suspense>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
